import { Button } from "@wags/ui/button.tsx";
import { Header } from "@/components/Header";
import { AuthErrorAlert } from "@/components/shared/auth-error-alert";
import { SettingsBackLink } from "@/components/shared/SettingsBackLink";
import {
    GOOGLE_SIGN_IN_START_FAILURE,
    useGoogleSignInStart,
} from "@/lib/core/auth-protocol";
import {
    oauthCallbackErrorMessage,
    resolveAuthPageRedirectUrl,
} from "./auth-redirect";

export function AuthPage({
    mode,
    redirectUrl,
    oauthError,
}: {
    mode: "sign-in" | "sign-up";
    redirectUrl?: string;
    oauthError?: string;
}) {
    const callbackURL = resolveAuthPageRedirectUrl(redirectUrl);
    const googleSignIn = useGoogleSignInStart();
    const error = googleSignIn.failed
        ? GOOGLE_SIGN_IN_START_FAILURE
        : googleSignIn.pending
          ? null
          : oauthCallbackErrorMessage(oauthError);
    return (
        <div className="w-full bg-maltese-white">
            <Header className="hidden md:block" hideSignIn />
            <main className="mx-auto flex w-full max-w-[1138px] flex-col px-5 pt-[calc(env(safe-area-inset-top)+20px)] pb-8 md:items-center md:px-6 md:pt-[132px] md:pb-24">
                <SettingsBackLink
                    href={callbackURL}
                    aria-label="Back to Wags"
                    label="Back"
                    className="mb-5 md:hidden"
                />
                <section className="flex w-full flex-col gap-6 card-lg bg-true-white ring-1 ring-black/[0.07] shadow-[0_24px_72px_-24px_rgba(49,36,28,0.22)] md:max-w-[32rem]">
                    <div className="space-y-2">
                        <h1 className="text-page-title text-doberman-black">
                            {mode === "sign-in"
                                ? "Welcome back"
                                : "Make Wags yours"}
                        </h1>
                        <p className="text-body text-doberman-black/60">
                            Continue with Google to reconnect saved dogs,
                            matches, and Kits conversations across devices.
                        </p>
                    </div>
                    {error ? <AuthErrorAlert message={error} /> : null}
                    <Button
                        type="button"
                        variant="dark"
                        size="lg"
                        disabled={googleSignIn.pending}
                        onClick={() => void googleSignIn.start(callbackURL)}
                    >
                        {googleSignIn.pending
                            ? "Opening Google…"
                            : "Continue with Google"}
                    </Button>
                    <p className="text-xs leading-5 text-doberman-black/45">
                        You can browse Wags privately without signing in. Google
                        is only used when you choose to sync your account.
                    </p>
                </section>
            </main>
        </div>
    );
}
